/**
 * The toasts of adding and opening files (the wall's Add files, a linked
 * file's Open, Show and Locate): each its own, so several stay readable.
 */
import { useNotificationStore } from "@/stores/notification-store";

let count = 0;

export function fileToast(
  level: "info" | "error",
  title: string,
  description?: string,
): void {
  count += 1;
  useNotificationStore.getState().addSystemToast({
    id: `file-${count}`,
    level,
    title,
    description,
  });
}
